import idGenerator from '@/lib/helpers/id-generator';

const appId = idGenerator();

export default {
  getFormByCif(cif) {
    return {
      data: {
        status: 'SUCCESS',
        data: {
          cif,
          'full-name': 'John Doe',
        },
      },
    };
  },
  formSubmission() {
    return {
      data: {
        'app-detail': {
          status: 'SUCCESS',
          'app-id': appId,
        },
      },
    };
  },
};
